import React, { useEffect, useState, Fragment } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom";
import { Col, Row, Label, FormGroup, Input, Card, CardBody } from "reactstrap";
import { Form, Field } from "react-final-form";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import "../../assets/custom css/loadoverlay.scss";
import Alerts from "../../components/Alerts/alerts";
import { SketchPicker } from "react-color";
import ConfigurationService from "./configuration.service";
import AuthService from "../Authentication/auth.service";
import PermissionAccess from '../../PermissionAccess/Access.js';
import { Tooltip } from "@mui/material";
import { uploadFile } from "../../utils/fileUtils";
import InfoIcon from "@mui/icons-material/Info";
import { useSensitiveInfo } from "../../context/SensitiveInfoContext";

const FieldInfoTooltip = ({ title }) => (
  <Tooltip placement="top" title={title} arrow>
    <span className="ms-2" style={{ display: "inline-flex", alignItems: "center", cursor: "help" }}>
      <InfoIcon style={{ color: "#17a2b8", fontSize: "18px" }} />
    </span>
  </Tooltip>
);

const TabGenralConfig = () => {

  // localStorage.setItem("buttons_color", '#3ac47d');

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [B64converted, setB64converted] = useState("");
  const [lhdn_submission_time, setLhdn_submission_time] = useState("");
  const [sync_lhdn_status, setSync_lhdn_status] = useState("");

  const [displayColorPicker1, setdisplayColorPicker1] = useState(false);
  const [sketchPickerColor1, setSketchPickerColor1] = useState(localStorage.getItem("buttons_color"));
  const color1 = sketchPickerColor1;

  const [displayColorPicker2, setdisplayColorPicker2] = useState(false);
  const [sketchPickerColor2, setSketchPickerColor2] = useState(localStorage.getItem("topbar_color"));
  const color2 = sketchPickerColor2;

  const [displayColorPicker3, setdisplayColorPicker3] = useState(false);
  const [sketchPickerColor3, setSketchPickerColor3] = useState(localStorage.getItem("leftbar_color"));
  const color3 = sketchPickerColor3;

  const [displayColorPicker4, setdisplayColorPicker4] = useState(false);
  const [sketchPickerColor4, setSketchPickerColor4] = useState(localStorage.getItem("buttons_text_color"));
  const color4 = sketchPickerColor4;


  const [configs, setConfig] = useState([]);
  const [sensitivePassword, setSensitivePassword] = useState("");
  const [sensitivePasswordConfirm, setSensitivePasswordConfirm] = useState("");
  const [sensitivePasswordSet, setSensitivePasswordSet] = useState(false);
  const [showRemovePasswordModal, setShowRemovePasswordModal] = useState(false);
  const [removePasswordInput, setRemovePasswordInput] = useState("");
  const [removePasswordError, setRemovePasswordError] = useState("");
  const [removingSensitivePassword, setRemovingSensitivePassword] = useState(false);
  const { t, i18n } = useTranslation();
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const { refreshPasswordFlag } = useSensitiveInfo();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    getSystemConfig();
  }, []);

  function getSystemConfig() {
    ConfigurationService.getConfiguration(authData.sessionID).then((response) => {
      console.log("API Response:-", response);
      if (response.data.status) {
        const [rec_data] = response.data.data;
        setConfig({
          ...rec_data,
          tracking_start_window_hours: rec_data.tracking_start_window_hours ?? 3,
          doctor_ledger_auto_pay_period_minutes: rec_data.doctor_ledger_auto_pay_period_minutes ?? 5,
          dispatch_order_auto_complete_hours: rec_data.dispatch_order_auto_complete_hours ?? 72,
        });
        setSensitivePasswordSet(Boolean(rec_data.sensitive_info_password_set));
        setSensitivePassword("");
        setSensitivePasswordConfirm("");
        setColors(response.data.data[0].buttons_color, '--buttons-color');
        setColors(response.data.data[0].topbar_color, '--topbar-color');
        setColors(response.data.data[0].leftbar_color, '--leftbar-color');
        setColors(response.data.data[0].buttons_text_color, '--buttons-text-color');
        setSystemLogo(response.data.data[0].system_logo);
        setLhdn_submission_time(response.data.data[0].lhdn_submission_time)
        setSync_lhdn_status(response.data.data[0].sync_lhdn_status)
      }
      else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        }
        else {
          setColors('#3ac47d', 'onerror');
          alert(t("Unable to retreive configurations at the moment."))
        }
      }
    },
      (error) => {
        setColors('#3ac47d', 'onerror');
        alert(t("Unable to retreive configurations at the moment."))
      });
  }

  function setColors(color, param) {
    if (param === '--buttons-color') {
      localStorage.setItem("buttons_color", color);
      setSketchPickerColor1(color)
      document.documentElement.style.setProperty('--buttons-color', color)
    }
    if (param === '--topbar-color') {
      localStorage.setItem("topbar_color", color);
      setSketchPickerColor2(color)
      document.documentElement.style.setProperty('--topbar-color', color)
    }
    if (param === '--leftbar-color') {
      localStorage.setItem("leftbar_color", color);
      setSketchPickerColor3(color)
      document.documentElement.style.setProperty('--leftbar-color', color)
    }
    if (param === '--buttons-text-color') {
      localStorage.setItem("buttons_text_color", color);
      setSketchPickerColor4(color)
      document.documentElement.style.setProperty('--buttons-text-color', color)
    }
    if (param === 'onerror') {
      localStorage.setItem("buttons_color", color);
      localStorage.setItem("topbar_color", '#fff');
      localStorage.setItem("leftbar_color", '#fff');
      localStorage.setItem("buttons_text_color", '#fff');
      document.documentElement.style.setProperty('--buttons-color', color)
      document.documentElement.style.setProperty('--topbar-color', '#fff')
      document.documentElement.style.setProperty('--leftbar-color', '#fff')
      document.documentElement.style.setProperty('--buttons-text-color', '#fff')
    }
  }

  function setSystemLogo(sys_logo) {
    localStorage.setItem("system_logo", sys_logo);
  }

  const onChangelogo = async (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }

    setLoading(true);
    try {
      const path = await uploadFile(file);
      setB64converted(path);
    } catch (error) {
      Alerts.swalErrorAlert(error.message || t("Image upload failed."));
    } finally {
      setLoading(false);
    }
  };



  function handleSave(values) {
    console.log("Form Values:-", values);
    setLoading(true);
    localStorage.setItem("buttons_color", sketchPickerColor1);
    document.documentElement.style.setProperty('--buttons-color', sketchPickerColor1);
    localStorage.setItem("topbar_color", sketchPickerColor2);
    document.documentElement.style.setProperty('--topbar-color', sketchPickerColor2);
    localStorage.setItem("leftbar_color", sketchPickerColor3);
    document.documentElement.style.setProperty('--leftbar-color', sketchPickerColor3);
    localStorage.setItem("buttons_text_color", sketchPickerColor4);
    document.documentElement.style.setProperty('--buttons-text-color', sketchPickerColor4);
    var payloadData = {
      functionName: "SetConfigurations",
      postData: {
        name: values.name,
        email: values.email,
        sara_share: values.sara_share,
        reappointment_exp_time: values.reappointment_exp_time,
        unsuccesful_bid_expiry: values.unsuccesful_bid_expiry,
        timeperiod_for_confirmed: values.timeperiod_for_confirmed,
        time_period_for_cancelled: values.time_period_for_cancelled,
        prescribed_order_exp_time: values.prescribed_order_exp_time,
        prescribed_bid_exp_time: values.prescribed_bid_exp_time,
        open_ai_key: values.open_ai_key,
        appointment_distance_range: values.appointment_distance_range,
        distance_extention_time: values.distance_extention_time,
        searchable_radius: values.searchable_radius,
        tracking_start_window_hours: (values.tracking_start_window_hours !== '' && values.tracking_start_window_hours != null) ? Number(values.tracking_start_window_hours) : 3,
        doctor_ledger_auto_pay_period_minutes: (values.doctor_ledger_auto_pay_period_minutes !== '' && values.doctor_ledger_auto_pay_period_minutes != null) ? Number(values.doctor_ledger_auto_pay_period_minutes) : 5,
        dispatch_order_auto_complete_hours: (values.dispatch_order_auto_complete_hours !== '' && values.dispatch_order_auto_complete_hours != null) ? Number(values.dispatch_order_auto_complete_hours) : 72,
        login_email: values.login_email,
        contact_us_email: values.contact_us_email,
        company_phone: values.company_phone,
        company_email: values.company_email,
        ssm_number: values.ssm_number,
        buttons_color: sketchPickerColor1,
        topbar_color: sketchPickerColor2,
        leftbar_color: sketchPickerColor3,
        buttons_text_color: sketchPickerColor4,
        lhdn_submission_time: lhdn_submission_time,
        // sync_lhdn_status: sync_lhdn_status,
        sync_lhdn_status: sync_lhdn_status === 'custom' ? customSyncLhdnStatus : sync_lhdn_status,
        // system_logo: B64converted
      },
    }
    if (B64converted) {
      payloadData.postData['system_logo'] = B64converted;
    }
    if (sensitivePassword || sensitivePasswordConfirm) {
      if (!sensitivePassword || !sensitivePasswordConfirm) {
        setLoading(false);
        Alerts.swalErrorAlert(t("Please enter and confirm the sensitive information password."));
        return;
      }
      if (sensitivePassword !== sensitivePasswordConfirm) {
        setLoading(false);
        Alerts.swalErrorAlert(t("Sensitive information passwords do not match."));
        return;
      }
      if (sensitivePassword.trim().length < 6) {
        setLoading(false);
        Alerts.swalErrorAlert(t("Sensitive information password must be at least 6 characters."));
        return;
      }
      payloadData.postData.sensitive_info_password = sensitivePassword.trim();
    }
    ConfigurationService.setConfiguration(authData.sessionID, payloadData).then((response) => {
      console.log("API Response:-", response);
      setLoading(false);
      if (response.data.status) {
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Configuration updated successfully."));
        }
        getSystemConfig();
        refreshPasswordFlag();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't update configuration at the moment. Please try again later."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        console.log("Error:-", error)
        Alerts.swalErrorAlert(t("Network Operation failed."))
      });
  }

  const validateFtn = (values) => {
    const errors = {};
    function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    if (!values.name) {
      errors.name = t("System Name Required.");
    }
    if (!values.email) {
      errors.email = t("Email Required.");
    }
    if (!values.login_email) {
      errors.login_email = t("Login Email Required.");
    }
    else if (!validateEmail(values.email)) {
      errors.email = t("Please enter a valid email address.");
    }
    if (!values.sara_share) {
      errors.sara_share = t('SARA Appointment Share % Required.');
    }
    if (!values.unsuccesful_bid_expiry) {
      errors.unsuccesful_bid_expiry = t('Unsuccessful Bid Expiry Required.');
    }
    if (!values.timeperiod_for_confirmed) {
      errors.timeperiod_for_confirmed = t('Time Period for Confirmation Required.');
    }
    if (!values.time_period_for_cancelled) {
      errors.time_period_for_cancelled = t('Time Period for Cancellation Required.');
    }
    if (!values.prescribed_order_exp_time) {
      errors.prescribed_order_exp_time = t('Prescribed Order Expiry Time Required.');
    }
    if (!values.prescribed_bid_exp_time) {
      errors.prescribed_bid_exp_time = t('Prescribed Bid Expiry Time Required.');
    }
    if (!values.searchable_radius) {
      errors.searchable_radius = t('Searchable Radius Required.');
    }
    return errors;
  };

  const openRemovePasswordModal = () => {
    setRemovePasswordInput("");
    setRemovePasswordError("");
    setShowRemovePasswordModal(true);
  };

  const closeRemovePasswordModal = () => {
    if (removingSensitivePassword) return;
    setShowRemovePasswordModal(false);
    setRemovePasswordInput("");
    setRemovePasswordError("");
  };

  const handleClearSensitivePassword = (event) => {
    if (event) event.preventDefault();
    if (!removePasswordInput.trim()) {
      setRemovePasswordError(t("Please enter the current password to remove protection."));
      return;
    }
    setRemovePasswordError("");
    setRemovingSensitivePassword(true);
    setLoading(true);
    const payloadData = {
      functionName: "SetConfigurations",
      postData: {
        sensitive_info_clear_password: true,
        sensitive_info_password: removePasswordInput.trim(),
      },
    };
    ConfigurationService.setConfiguration(authData.sessionID, payloadData).then((response) => {
      setLoading(false);
      setRemovingSensitivePassword(false);
      if (response.data.status) {
        setShowRemovePasswordModal(false);
        setRemovePasswordInput("");
        setRemovePasswordError("");
        Alerts.swalSuccessAlert(t("Sensitive information password removed."));
        setSensitivePasswordSet(false);
        refreshPasswordFlag();
      } else if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else {
        setRemovePasswordError(response.data.message || t("Unable to remove password."));
      }
    }, () => {
      setLoading(false);
      setRemovingSensitivePassword(false);
      setRemovePasswordError(t("Network Operation failed."));
    });
  };

  const colorPicker = (val) => {
    if (val === '1') {
      setdisplayColorPicker1(true);
    }
    if (val === '2') {
      setdisplayColorPicker2(true);
    }
    if (val === '3') {
      setdisplayColorPicker3(true);
    }
    if (val === '4') {
      setdisplayColorPicker4(true);
    }
  };

  const handleClose = (val) => {
    if (val === '1') {
      setdisplayColorPicker1(false);
    }
    if (val === '2') {
      setdisplayColorPicker2(false);
    }
    if (val === '3') {
      setdisplayColorPicker3(false);
    }
    if (val === '4') {
      setdisplayColorPicker4(false);
    }
  };

  const popover = {
    position: "absolute",
    zIndex: "2",
  };
  const cover = {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
  };


  const [customLhdnSubmissionTime, setCustomLhdnSubmissionTime] = useState('');
  const [customSyncLhdnStatus, setCustomSyncLhdnStatus] = useState('');
  const [showCustomCronModal, setShowCustomCronModal] = useState(false);
  const [currentCustomField, setCurrentCustomField] = useState('');

  // Add this function to handle custom cron input
  const handleCustomCronInput = (field) => {
    setCurrentCustomField(field);
    setShowCustomCronModal(true);
  };

  // Add this function to save the custom cron input
  const saveCustomCronInput = (customCronString) => {
    if (currentCustomField === 'lhdn_submission_time') {
      setLhdn_submission_time(customCronString);
      setCustomLhdnSubmissionTime(customCronString);
    } else if (currentCustomField === 'sync_lhdn_status') {
      setSync_lhdn_status(customCronString);
      setCustomSyncLhdnStatus(customCronString);
    }
    setShowCustomCronModal(false);
  };

  // Add a modal component for custom cron input
  const CustomCronModal = () => {
    const [customCronString, setCustomCronString] = useState('');

    return (
      <Modal isOpen={showCustomCronModal} toggle={() => setShowCustomCronModal(false)}>
        <ModalHeader toggle={() => setShowCustomCronModal(false)}>Enter Custom Cron Schedule</ModalHeader>
        <ModalBody>
          <Input
            type="text"
            placeholder="e.g., */15 * * * *"
            value={customCronString}
            onChange={(e) => setCustomCronString(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowCustomCronModal(false)}>Cancel</Button>
          <Button color="primary" onClick={() => saveCustomCronInput(customCronString)}>Save</Button>
        </ModalFooter>
      </Modal>
    );
  };




  useEffect(() => {
    if (!showRemovePasswordModal) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [showRemovePasswordModal]);

  return (
    <Fragment>
      {showCustomCronModal && <CustomCronModal />}
      {showRemovePasswordModal
        ? ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              zIndex: 100000,
              background: "rgba(0, 0, 0, 0.55)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 16,
            }}
            onClick={closeRemovePasswordModal}
          >
            <div
              className="rounded shadow-lg"
              style={{
                width: "100%",
                maxWidth: 460,
                background: "#ffffff",
                color: "#212529",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <form onSubmit={handleClearSensitivePassword}>
                <div className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
                  <h5 className="mb-0">{t("Remove password protection")}</h5>
                  <button type="button" className="btn-close" onClick={closeRemovePasswordModal} disabled={removingSensitivePassword} />
                </div>
                <div className="px-4 py-3">
                  {removePasswordError ? (
                    <div className="alert alert-danger py-2 mb-3" role="alert">
                      {removePasswordError}
                    </div>
                  ) : null}
                  <p className="mb-3">
                    {t("Sensitive information will become visible to all admins. Enter the current password to confirm.")}
                  </p>
                  <label className="fw-semibold form-label">{t("Current Password")}</label>
                  <input
                    type="password"
                    className={`form-control ${removePasswordError ? "is-invalid" : ""}`}
                    autoFocus
                    value={removePasswordInput}
                    onChange={(e) => {
                      setRemovePasswordInput(e.target.value);
                      if (removePasswordError) setRemovePasswordError("");
                    }}
                    placeholder={t("Enter password")}
                    autoComplete="off"
                  />
                </div>
                <div className="d-flex justify-content-end gap-2 px-4 py-3 border-top">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeRemovePasswordModal}
                    disabled={removingSensitivePassword}
                  >
                    {t("Cancel")}
                  </button>
                  <button type="submit" className="btn btn-danger" disabled={removingSensitivePassword}>
                    {removingSensitivePassword ? t("Removing...") : t("Remove protection")}
                  </button>
                </div>
              </form>
            </div>
          </div>,
          document.body
        )
        : null}
      <div className="container-fluid px-4 py-4">
        <div className="row justify-content-center">
          <div className="col-12 col-xl-10">
            <Card className="shadow-lg border-0" style={{ borderRadius: '15px' }}>
              <CardBody className="p-4">
                <div className="text-center mb-4">
                  <h2 className="fw-bold text-dark mb-2">{t('System Configuration')}</h2>
                  <p className="text-muted">{t('Manage your system settings and preferences')}</p>
                </div>

                <Form
                  initialValues={configs}
                  validate={validateFtn}
                  onSubmit={handleSave}
                  FormState
                  render={({ handleSubmit, values, submitting, validating, valid, form: { getState } }) => (
                    <form onSubmit={handleSubmit}>
                      <LoadingOverlay tag="div" active={loading}
                        styles={{ overlay: (base) => ({ ...base }) }}
                        spinner={<DNALoader />}>

                        {/* Basic Information Section */}
                        <Card className="mb-4 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <h5 className="fw-semibold text-dark mb-4 d-flex align-items-center">
                              <i className="fas fa-info-circle me-2" style={{ color: 'var(--buttons-color)' }}></i>
                              {t('Basic Information')}
                            </h5>
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="name">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="name" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('System Name')} <span className="text-danger">*</span>
                                          <FieldInfoTooltip title={t('Display name of this system used in branding and across the admin panel.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="text"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter system name')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="email">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="email" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Admin Email')} <span className="text-danger">*</span>
                                          <FieldInfoTooltip title={t('Primary administrator email for this system.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="email"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter admin email')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="contact_us_email">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="contact_us_email" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Contact Us Email')}
                                          <FieldInfoTooltip title={t('Email address that receives Contact Us form submissions from users.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="email"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Email to receive Contact Us queries')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                        <div className="text-muted small mt-1">{t('Contact form submissions will be emailed to this address')}</div>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>

                        {/* Company Information Section */}
                        <Card className="mb-4 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <h5 className="fw-semibold text-dark mb-4 d-flex align-items-center">
                              <i className="fas fa-building me-2" style={{ color: 'var(--buttons-color)' }}></i>
                              {t('Company Information')}
                            </h5>
                            <Row>
                              <Col md={4}>
                                <FormGroup className="mb-3">
                                  <Field name="company_phone">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="company_phone" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Company Phone Number')}
                                          <FieldInfoTooltip title={t('Public company phone number shown for contact and support purposes.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="tel"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter company phone number')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup className="mb-3">
                                  <Field name="company_email">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="company_email" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Company Email')}
                                          <FieldInfoTooltip title={t('Public company email address used for business contact details.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="email"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter company email')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup className="mb-3">
                                  <Field name="ssm_number">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="ssm_number" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('SSM Number')}
                                          <FieldInfoTooltip title={t('Company SSM (business registration) number.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="text"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter SSM number')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>

                        {/* <FormGroup>
                        <Field name="lhdn_submission_time">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="temp_subject" className="col-sm-2 col-form-label">{t('LHDN Submission Time')}</Label>
                                <div className="col-sm-10">
                                  <select {...input}
                                    value={lhdn_submission_time}
                                    onChange={event => setLhdn_submission_time(event.target.value)}
                                    className="form-select" name="is_required"
                                  >
                                    <option disabled={true} value="">{t('--Choose an timing--')}</option>
                                    <option key="0" value="0">{t('Immediately')}</option>
                                    <option key="5" value="5">{t('After Five Minutes')}</option>
                                    <option key="30" value="30">{t('After Thirty Minutes')}</option>
                                    <option key="60" value="60">{t('After an Hour')}</option>
                                    <option key="720" value="720">{t('After Twelve Hour')}</option>
                                    <option key="1440" value="1440">{t('After a Day')}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup> */}

                        {/* <FormGroup>
                        <Field name="sync_lhdn_status">
                          {({ input, meta }) => (
                            <div>
                              <div className="row mb-3">
                                <Label for="temp_subject" className="col-sm-2 col-form-label">{t('Sync LHDN Status')}</Label>
                                <div className="col-sm-10">
                                  <select
                                    {...input}
                                    value={sync_lhdn_status}
                                    onChange={(event) => {
                                      setSync_lhdn_status(event.target.value);
                                      if (event.target.value === 'custom') {
                                        // Open a modal or expand a form for custom cron input
                                        handleCustomCronInput('sync_lhdn_status');
                                      }
                                    }}
                                    className="form-select"
                                    name="is_required"
                                  >
                                    <option disabled={true} value="">{t('--Choose a schedule--')}</option>
                                    <option value="* * * * *">{t('Every minute')}</option>
                                    <option value="5 * * * *">{t('Every 5 minutes')}</option>
                                    <option value="15 * * * *">{t('Every 15 minutes')}</option>
                                    <option value="0,30 * * * *">{t('Twice per hour')}</option>
                                    <option value="0 * * * *">{t('Once per hour')}</option>
                                    <option value="0 0,12 * * *">{t('Twice per day')}</option>
                                    <option value="0 0 * * *">{t('Once per day')}</option>
                                    <option value="0 0 * * 0">{t('Once per week')}</option>
                                    <option value="0 0 1 * *">{t('Once per month')}</option>
                                    <option value="custom">{t('Custom schedule')}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </FormGroup> */}

                        {/* Business Settings Section */}
                        <Card className="mb-4 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <h5 className="fw-semibold text-dark mb-4 d-flex align-items-center">
                              <i className="fas fa-cogs me-2" style={{ color: 'var(--buttons-color)' }}></i>
                              {t('Business Settings')}
                            </h5>
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="login_email">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="login_email" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Login Alert Email')} <span className="text-danger">*</span>
                                          <FieldInfoTooltip title={t('Email address that receives login alert notifications.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="email"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter login alert email')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="sara_share">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="sara_share" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('SARA Appointment Share %')} <span className="text-danger">*</span>
                                          <FieldInfoTooltip title={t('Applies to: Platform. Percentage of the appointment fee retained by SARA / the company; the remainder goes to the doctor.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter percentage')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="reappointment_exp_time">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="reappointment_exp_time" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Reappointment Expiry Time (mins)')} <span className="text-danger">*</span>
                                          <FieldInfoTooltip title={t('Applies to: Patient & Doctor. How long (in minutes) a reappointment offer stays valid before it expires.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter miutes')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                        {/* Time Period Settings Section */}
                        <Card className="mb-4 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <h5 className="fw-semibold text-dark mb-4 d-flex align-items-center">
                              <i className="fas fa-clock me-2" style={{ color: 'var(--buttons-color)' }}></i>
                              {t('Time Period Settings')}
                            </h5>
                            <Row>
                              <Col md={4}>
                                <FormGroup className="mb-3">
                                  <Field name="unsuccesful_bid_expiry">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="unsuccesful_bid_expiry" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Unsuccessful Bid Expiry (mins)')} <span className="text-danger">*</span>
                                          <Tooltip
                                            placement="top"
                                            title={t('Applies to: Doctor. How long (in minutes) a doctor\'s unaccepted appointment bid stays active before it is automatically marked as expired.')}
                                            arrow
                                          >
                                            <span className="ms-2" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                                              <InfoIcon style={{ color: '#17a2b8', fontSize: '18px' }} />
                                            </span>
                                          </Tooltip>
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter minutes')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup className="mb-3">
                                  <Field name="timeperiod_for_confirmed">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="timeperiod_for_confirmed" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Appointment Status Update (mins)')} <span className="text-danger">*</span>
                                          <Tooltip
                                            placement="top"
                                            title={t('Applies to: Patient & Doctor. Time (in minutes) after an accepted appointment\'s slot time when the appointment is automatically marked as completed.')}
                                            arrow
                                          >
                                            <span className="ms-2" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                                              <InfoIcon style={{ color: '#17a2b8', fontSize: '18px' }} />
                                            </span>
                                          </Tooltip>
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter minutes')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup className="mb-3">
                                  <Field name="time_period_for_cancelled">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="time_period_for_cancelled" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Appointment Cancellation Time (mins)')} <span className="text-danger">*</span>
                                          <Tooltip
                                            placement="top"
                                            title={t('Applies to: Patient. Time (in minutes) after a new appointment request is created with no doctor bids; the request is then cancelled automatically.')}
                                            arrow
                                          >
                                            <span className="ms-2" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                                              <InfoIcon style={{ color: '#17a2b8', fontSize: '18px' }} />
                                            </span>
                                          </Tooltip>
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter minutes')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup className="mb-3">
                                  <Field name="tracking_start_window_hours">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="tracking_start_window_hours" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Tracking Start Window (hours)')}
                                          <Tooltip
                                            placement="top"
                                            title={t('Applies to: Doctor. For scheduled appointments, the doctor can start tracking only within this many hours after the appointment slot time. Immediate prescriptions can always start tracking anytime. Default: 3 hours.')}
                                            arrow
                                          >
                                            <span className="ms-2" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                                              <InfoIcon style={{ color: '#17a2b8', fontSize: '18px' }} />
                                            </span>
                                          </Tooltip>
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          min={1}
                                          step={1}
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('e.g. 3')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                        <div className="text-muted small mt-1">{t('Scheduled appointments: doctor can start tracking only within this window after slot time.')}</div>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup className="mb-3">
                                  <Field name="doctor_ledger_auto_pay_period_minutes">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="doctor_ledger_auto_pay_period_minutes" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Doctor Ledger Auto-Pay Period (mins)')}
                                          <Tooltip
                                            placement="top"
                                            title={t('Applies to: Doctor. How long (in minutes) a doctor ledger entry stays in "In Progress" before automatically moving to "Paid". Default: 5 minutes (testing) or 4320 minutes / 3 days (production).')}
                                            arrow
                                          >
                                            <span className="ms-2" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                                              <InfoIcon style={{ color: '#17a2b8', fontSize: '18px' }} />
                                            </span>
                                          </Tooltip>
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          min={1}
                                          step={1}
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('e.g. 5 (testing) or 4320 (3 days)')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                        <div className="text-muted small mt-1">{t('After this period, "In Progress" payments automatically become "Paid"')}</div>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={4}>
                                <FormGroup className="mb-3">
                                  <Field name="dispatch_order_auto_complete_hours">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="dispatch_order_auto_complete_hours" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Dispatch → Complete after (hours)')}
                                          <Tooltip
                                            placement="top"
                                            title={t('Applies to: Service Provider (Pharmacy). Delivery orders only (self collect off). If status stays Dispatch or Dispatched longer than this many hours, the order is set to Completed automatically. Example: 72 = 3 days. Default: 72.')}
                                            arrow
                                          >
                                            <span className="ms-2" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                                              <InfoIcon style={{ color: '#17a2b8', fontSize: '18px' }} />
                                            </span>
                                          </Tooltip>
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          min={1}
                                          step={1}
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('e.g. 72')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                        <div className="text-muted small mt-1">{t('Applies to non-prescribed (DeviceOrder) and prescribed (PrescribedCart) orders when self collect is false.')}</div>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="prescribed_order_exp_time">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="prescribed_order_exp_time" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Prescribed Order Deletion Time (mins)')} <span className="text-danger">*</span>
                                          <Tooltip
                                            placement="top"
                                            title={t('Applies to: Patient. Time (in minutes) after a prescribed order is placed with no pharmacy bids; the order is then deleted automatically.')}
                                            arrow
                                          >
                                            <span className="ms-2" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                                              <InfoIcon style={{ color: '#17a2b8', fontSize: '18px' }} />
                                            </span>
                                          </Tooltip>
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter minutes')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="prescribed_bid_exp_time">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="prescribed_bid_exp_time" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Prescribed Bid Deletion Time (mins)')} <span className="text-danger">*</span>
                                          <Tooltip
                                            placement="top"
                                            title={t('Applies to: Service Provider (Pharmacy). How long (in minutes) an unaccepted pharmacy bid stays active before being deleted automatically.')}
                                            arrow
                                          >
                                            <span className="ms-2" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                                              <InfoIcon style={{ color: '#17a2b8', fontSize: '18px' }} />
                                            </span>
                                          </Tooltip>
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter minutes')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>

                        {/* API & Location Settings Section */}
                        <Card className="mb-4 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <h5 className="fw-semibold text-dark mb-4 d-flex align-items-center">
                              <i className="fas fa-robot me-2" style={{ color: 'var(--buttons-color)' }}></i>
                              {t('API & Location Settings')}
                            </h5>
                            <Row>
                              <Col md={12}>
                                <FormGroup className="mb-3">
                                  <Field name="open_ai_key">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="open_ai_key" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('OpenAI API Key')}
                                          <FieldInfoTooltip title={t('API key used by the system for OpenAI-powered AI features. Keep this key private and do not share it.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="textarea"
                                          style={{
                                            minHeight: "100px",
                                            borderRadius: '10px',
                                            border: '2px solid #e9ecef',
                                            resize: 'vertical'
                                          }}
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter your OpenAI API key for AI features')}
                                          className="form-control"
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="appointment_distance_range">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="appointment_distance_range" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Appointment Distance Range (km)')}
                                          <FieldInfoTooltip title={t('Applies to: Patient & Doctor/Nurse. Maximum distance (in kilometers) from the patient\'s address within which doctors or nurses are matched for appointments.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter distance range')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="distance_extention_time">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="distance_extention_time" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Distance Extension Time (minutes)')}
                                          <FieldInfoTooltip title={t('Applies to: Appointment matching. Time (in minutes) related to extending or adjusting the appointment search distance window.')} />
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter extension time')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>

                        {/* Pharmacy Settings Section */}
                        <Card className="mb-4 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <h5 className="fw-semibold text-dark mb-4 d-flex align-items-center">
                              <i className="fas fa-prescription-bottle-alt me-2" style={{ color: 'var(--buttons-color)' }}></i>
                              {t('Universal Radius Settings')}
                            </h5>
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Field name="searchable_radius">
                                    {({ input, meta }) => (
                                      <div>
                                        <Label for="searchable_radius" className="form-label fw-semibold text-dark d-flex align-items-center">
                                          {t('Searchable Radius (km)')} <span className="text-danger">*</span>
                                          <Tooltip
                                            placement="top"
                                            title={t('This setting defines the maximum distance (in kilometers) within which pharmacies and service providers will be searched for fulfilling orders and prescribed requests.')}
                                            arrow
                                          >
                                            <span className="ms-2" style={{ display: 'inline-flex', alignItems: 'center', cursor: 'help' }}>
                                              <InfoIcon style={{ color: '#17a2b8', fontSize: '18px' }} />
                                            </span>
                                          </Tooltip>
                                        </Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Enter searchable radius')}
                                          className="form-control-lg"
                                          style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                        />
                                        {meta.error && meta.touched &&
                                          <div className="text-danger small mt-1">{meta.error}</div>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>

                        {/* Theme Colors Section */}
                        <Card className="mb-4 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <h5 className="fw-semibold text-dark mb-4 d-flex align-items-center">
                              <i className="fas fa-palette me-2" style={{ color: 'var(--buttons-color)' }}></i>
                              {t('Theme Colors')}
                            </h5>
                            <p className="text-muted mb-4">{t('Customize the appearance of your application')}</p>

                            <Row>
                              <Col md={6} className="mb-4">
                                <div className="d-flex align-items-center">
                                  <div className="me-3">
                                    <Label className="form-label fw-semibold text-dark mb-0 d-flex align-items-center">
                                      {t('Button Background')}
                                      <FieldInfoTooltip title={t('Primary background color used for buttons across the application.')} />
                                    </Label>
                                    <small className="text-muted d-block">{t('Primary button color')}</small>
                                  </div>
                                  <div className="ms-auto">
                                    <button
                                      className="btn btn-lg shadow-sm"
                                      type="button"
                                      style={{
                                        backgroundColor: color1,
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '15px',
                                        border: '3px solid #fff',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                                      }}
                                      onClick={() => colorPicker('1')}
                                    >
                                      <i className="fas fa-paint-brush text-white"></i>
                                    </button>
                                    {displayColorPicker1 && (
                                      <div style={popover}>
                                        <div style={cover} onClick={() => handleClose('1')} />
                                        <SketchPicker
                                          className="mx-auto mb-4 shadow-lg"
                                          onChange={(color) => {
                                            setSketchPickerColor1(color.hex);
                                          }}
                                          color={sketchPickerColor1}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>

                              <Col md={6} className="mb-4">
                                <div className="d-flex align-items-center">
                                  <div className="me-3">
                                    <Label className="form-label fw-semibold text-dark mb-0 d-flex align-items-center">
                                      {t('Button Text')}
                                      <FieldInfoTooltip title={t('Text color shown on primary buttons.')} />
                                    </Label>
                                    <small className="text-muted d-block">{t('Text color on buttons')}</small>
                                  </div>
                                  <div className="ms-auto">
                                    <button
                                      className="btn btn-lg shadow-sm"
                                      type="button"
                                      style={{
                                        backgroundColor: color4,
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '15px',
                                        border: '3px solid #fff',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                                      }}
                                      onClick={() => colorPicker('4')}
                                    >
                                      <i className="fas fa-font text-white"></i>
                                    </button>
                                    {displayColorPicker4 && (
                                      <div style={popover}>
                                        <div style={cover} onClick={() => handleClose('4')} />
                                        <SketchPicker
                                          className="mx-auto mb-4 shadow-lg"
                                          onChange={(color) => {
                                            setSketchPickerColor4(color.hex);
                                          }}
                                          color={sketchPickerColor4}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>

                              <Col md={6} className="mb-4">
                                <div className="d-flex align-items-center">
                                  <div className="me-3">
                                    <Label className="form-label fw-semibold text-dark mb-0 d-flex align-items-center">
                                      {t('Top Bar')}
                                      <FieldInfoTooltip title={t('Background color of the top header / navigation bar.')} />
                                    </Label>
                                    <small className="text-muted d-block">{t('Header navigation color')}</small>
                                  </div>
                                  <div className="ms-auto">
                                    <button
                                      className="btn btn-lg shadow-sm"
                                      type="button"
                                      style={{
                                        backgroundColor: color2,
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '15px',
                                        border: '3px solid #fff',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                                      }}
                                      onClick={() => colorPicker('2')}
                                    >
                                      <i className="fas fa-window-maximize text-white"></i>
                                    </button>
                                    {displayColorPicker2 && (
                                      <div style={popover}>
                                        <div style={cover} onClick={() => handleClose('2')} />
                                        <SketchPicker
                                          className="mx-auto mb-4 shadow-lg"
                                          onChange={(color) => {
                                            setSketchPickerColor2(color.hex);
                                          }}
                                          color={sketchPickerColor2}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>

                              <Col md={6} className="mb-4">
                                <div className="d-flex align-items-center">
                                  <div className="me-3">
                                    <Label className="form-label fw-semibold text-dark mb-0 d-flex align-items-center">
                                      {t('Left Bar')}
                                      <FieldInfoTooltip title={t('Background color of the left sidebar navigation.')} />
                                    </Label>
                                    <small className="text-muted d-block">{t('Sidebar navigation color')}</small>
                                  </div>
                                  <div className="ms-auto">
                                    <button
                                      className="btn btn-lg shadow-sm"
                                      type="button"
                                      style={{
                                        backgroundColor: color3,
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '15px',
                                        border: '3px solid #fff',
                                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                                      }}
                                      onClick={() => colorPicker('3')}
                                    >
                                      <i className="fas fa-bars text-white"></i>
                                    </button>
                                    {displayColorPicker3 && (
                                      <div style={popover}>
                                        <div style={cover} onClick={() => handleClose('3')} />
                                        <SketchPicker
                                          className="mx-auto mb-4 shadow-lg"
                                          onChange={(color) => {
                                            setSketchPickerColor3(color.hex);
                                          }}
                                          color={sketchPickerColor3}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>

                        {/* Logo Upload Section */}
                        <Card className="mb-4 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <h5 className="fw-semibold text-dark mb-4 d-flex align-items-center">
                              <i className="fas fa-image me-2" style={{ color: 'var(--buttons-color)' }}></i>
                              {t('System Logo')}
                            </h5>
                            <FormGroup>
                              <Field name="file">
                                {({ input, meta }) => (
                                  <div>
                                    <Label for="file" className="form-label fw-semibold text-dark d-flex align-items-center">
                                      {t('Upload Logo')}
                                      <FieldInfoTooltip title={t('Upload the system logo image used in branding across the application.')} />
                                    </Label>
                                    <div className="border rounded-3 p-4 text-center" style={{
                                      border: '2px dashed #dee2e6',
                                      backgroundColor: '#fff',
                                      borderRadius: '15px'
                                    }}>
                                      <i className="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                                      <p className="text-muted mb-3">{t('Choose a logo file to upload')}</p>
                                      <Input
                                        {...input}
                                        type="file"
                                        value={values.file}
                                        onChange={onChangelogo}
                                        className="form-control form-control-lg"
                                        style={{ borderRadius: '10px' }}
                                        accept="image/*"
                                      />
                                    </div>
                                    {meta.error && meta.touched &&
                                      <div className="text-danger small mt-2">{meta.error}</div>}
                                  </div>
                                )}
                              </Field>
                            </FormGroup>
                          </CardBody>
                        </Card>

                        <Card className="mb-4 border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <h5 className="fw-semibold text-dark mb-2 d-flex align-items-center">
                              <i className="fas fa-user-shield me-2" style={{ color: 'var(--buttons-color)' }}></i>
                              {t('Sensitive Information Password')}
                            </h5>
                            <p className="text-muted mb-4">
                              {t('Admins must enter this password to view NRIC, IC images, face photos and medical documents for doctors, patients and merchants.')}
                            </p>
                            <div className="mb-3">
                              <span
                                className={`badge ${sensitivePasswordSet ? "bg-success" : "bg-secondary"}`}
                              >
                                {sensitivePasswordSet
                                  ? t("Password is set — sensitive fields are locked")
                                  : t("No password set — sensitive fields are visible")}
                              </span>
                            </div>
                            <Row>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Label className="form-label fw-semibold text-dark d-flex align-items-center">
                                    {sensitivePasswordSet ? t("New Password") : t("Password")}
                                    <FieldInfoTooltip title={t('Password required for admins to view sensitive fields such as NRIC, IC images, face photos and medical documents. Leave blank when updating other settings if you want to keep the current password.')} />
                                  </Label>
                                  <Input
                                    type="password"
                                    value={sensitivePassword}
                                    onChange={(e) => setSensitivePassword(e.target.value)}
                                    placeholder={sensitivePasswordSet ? t("Leave blank to keep current password") : t("Set a password")}
                                    autoComplete="new-password"
                                    className="form-control-lg"
                                    style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className="mb-3">
                                  <Label className="form-label fw-semibold text-dark d-flex align-items-center">
                                    {t("Confirm Password")}
                                    <FieldInfoTooltip title={t('Re-enter the sensitive information password to confirm it matches.')} />
                                  </Label>
                                  <Input
                                    type="password"
                                    value={sensitivePasswordConfirm}
                                    onChange={(e) => setSensitivePasswordConfirm(e.target.value)}
                                    placeholder={t("Re-enter password")}
                                    autoComplete="new-password"
                                    className="form-control-lg"
                                    style={{ borderRadius: '10px', border: '2px solid #e9ecef' }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            {sensitivePasswordSet ? (
                              <button
                                type="button"
                                className="btn btn-outline-danger"
                                onClick={openRemovePasswordModal}
                              >
                                {t("Remove password protection")}
                              </button>
                            ) : null}
                          </CardBody>
                        </Card>

                        {/* Action Buttons */}
                        <Card className="border-0" style={{ backgroundColor: '#f8f9fa' }}>
                          <CardBody className="p-4">
                            <div className="d-flex justify-content-center gap-3">
                              <button
                                type="button"
                                onClick={() => navigate(-1)}
                                className="btn btn-outline-secondary btn-lg px-5 py-3"
                                style={{
                                  borderRadius: '15px',
                                  fontWeight: '600',
                                  minWidth: '140px'
                                }}
                              >
                                <i className="fas fa-times me-2"></i>
                                {t('Cancel')}
                              </button>
                              <button
                                className="btn btn-lg px-5 py-3"
                                type="submit"
                                disabled={!valid}
                                style={{
                                  backgroundColor: 'var(--buttons-color)',
                                  borderColor: 'var(--buttons-color)',
                                  color: 'var(--buttons-text-color)',
                                  borderRadius: '15px',
                                  fontWeight: '600',
                                  minWidth: '140px',
                                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                }}
                              >
                                <i className="fas fa-save me-2"></i>
                                {t('Save Configuration')}
                              </button>
                            </div>
                          </CardBody>
                        </Card>
                      </LoadingOverlay>
                    </form>
                  )}
                />
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </Fragment>
  );

};
export default TabGenralConfig; 